// extracted by css-extract-rspack-plugin
export default {"preview-wrapper":"TravelReceiptsPreview_preview-wrapper__YFIN+"};